


// export default {
//   state: {

//   },
//   getters: {

//   },
//   mutations: {

//   },
//   actions: {}
// }


export default {
  state: {
    globalLoading: true,
    lastRoute: { name: 'home' }
  },
  getters: {

  },
  mutations: {
    setLoading(state, isLoading) {
      // console.log(isLoading);
      state.globalLoading = isLoading;
    },
    setData(state, param) {//param:{key:*,val:*}
      // console.log(param)
      var val = param.val;
      if (typeof param.val == "object") {
        val = JSON.stringify(val);
      }

      eval(`state.${param.key}=${val}`);
    },
  },
  actions: {}
}
